import {Component, Injector} from '@angular/core';
import {
    EdocEvent,
    EdocEventType,
    EdocOptions,
    NotificationType,
    PesFormatNamingContextRegistry,
    PesTaskEventType,
    ScrollService,
    StepButtonBuilder,
    StepValidateComponent,
    SubscriptionManager,
    ViewUrlEvent
} from '@pes/ui';
import {finalize, mergeMap} from 'rxjs/operators';
import {ISubscription} from 'rxjs/Subscription';


/**
 * The view loaded into a circuit for validating documents.
 */
@Component({
    selector: 'pes-action-validate',
    templateUrl: './step-validate.component.html'
})
export class LbpaStepValidateComponent extends StepValidateComponent {

    /**
     * Reference to the PES ScrollService service.
     */
    private readonly _scrollService: ScrollService = null;

    constructor(protected injector: Injector) {
        super(injector);
        this._scrollService = injector.get(ScrollService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        // set page name for analytics
    }

    /**
     * @inheritDoc
     */
    protected initStepButtons(): void {
    }

    /**
     * Refreshes the eDoc URL.
     */
    protected refresh(): void {
        const taskRef: string = this.task.reference;
        const edocOptions: EdocOptions[] = this.step.edocOptions;
        this.orchestrator.forceLoading(true);
        const sub: ISubscription = this.taskService.sendTaskEvent(
            taskRef, ViewUrlEvent.create(PesTaskEventType.REFRESH, edocOptions)
        ).pipe(
            finalize(() => this.orchestrator.forceLoading(false)),
            mergeMap(() => this.taskService.refresh(taskRef))
        ).subscribe(task => {
            this.task = task;
            this.stepTransactionManager.update(task);
        });
        SubscriptionManager.getInstance().registerSubscription(this, sub);
    }

    /**
     * Invoked each time the edoc component list dispatches an edoc event.
     *
     * @param {EdocEvent} event the event responsible for the method invocation.
     */
    protected onEdocEventHandler(event: EdocEvent): void {
        if (event.type !== 'edoc.userAlive' as EdocEventType) {
            if (event.type === EdocEventType.EDOC_DOCREAD_ALL) {
                const transactionId: string = event.transactionId;
                this.stepTransactionManager.allDocumentRead(transactionId);
                this.stepButtons = [
                    StepButtonBuilder.build(
                        this.step.positiveLabel || 'validate_step.submit',
                        NotificationType.PRIMARY,
                        this.submit.bind(this)
                    )
                ];
                this.notifyInitStepButtons();
            } else if (event.type === EdocEventType.EDOC_PAGELOADED && event.data.docIndex !== 0) {
                this._scrollService.scrollTo();
            }
        }
    }
}

PesFormatNamingContextRegistry.getInstance().delete(LbpaStepValidateComponent.VIEW_REF);
PesFormatNamingContextRegistry.getInstance().add(LbpaStepValidateComponent.VIEW_REF, LbpaStepValidateComponent);



// WEBPACK FOOTER //
// ./src/app/component/step-validate/step-validate.component.ts